import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { ROUTE_CONTABILIDAD , ROUTE_HERRAMIENTAS} from '../constants/constant.model';

@Injectable({
  providedIn: 'root'
})
export class PlanillaLiquidacionService {

  constructor(private apiService: ApiService,
    private http: HttpClient) {
  }

  contabilizar(data: any): Observable<any> {
    this.apiService.setUrlPathApi(`cuentas-por-pagar/planilla-pagos`+`/contabilizar`);
    return this.apiService.executePutJson(data).pipe();
  }

  //guardar
  insertar(data: any): Observable<any> {
    this.apiService.setUrlPathApi(`planilla-liquidacion`);
    return this.apiService.executePostJson(data).pipe();
  }

  actualizar(data: any): Observable<any> {
    this.apiService.setUrlPathApi(`planilla-liquidacion`);
    return this.apiService.executePutJson(data).pipe();
  }

  calcular(data: any): Observable<any> {
    this.apiService.setUrlPathApi(`planilla-liquidacion`+`/calcular`);
    return this.apiService.executePutJson(data).pipe();
  }

  aprobar(data: any): Observable<any> {
    this.apiService.setUrlPathApi(`planilla-liquidacion`+`/aprobar`);
    return this.apiService.executePutJson(data).pipe();
  }

  desaprobar(libro: string, periodo: number, mes: number, secuencia: any): Observable<any> {
    this.apiService.setUrlPathApi(`planilla-liquidacion`+`/desaprobar/${libro}/${periodo}/${mes}/${secuencia}`);
    return this.apiService.executePutJson(null).pipe();
  }

  anular(libro: string, periodo: number, mes: number, secuencia: any): Observable<any> {
    this.apiService.setUrlPathApi(`planilla-liquidacion`+`/anular/${libro}/${periodo}/${mes}/${secuencia}`);
    return this.apiService.executePutJson(null).pipe();
  }
  
  buscar_asiento(libro: string, periodo: number, mes: number, situac: string,offset:any, limit:any): Observable<any> {
    this.apiService.setUrlPathApi(`planilla-liquidacion`+`/asientos`);
    return this.apiService.execGetQueryJson(`/${libro}/${periodo}/${mes}?&offset=${offset}&limit=${limit}&situac=${situac}`).pipe();
  }

  obtener(libro: string, periodo: number, mes: number, secuencia:any): Observable<any> {
    this.apiService.setUrlPathApi(`planilla-liquidacion`);
    return this.apiService.execGetQueryJson(`/${libro}/${periodo}/${mes}/${secuencia}`).pipe();
  }

  obtener2(libro: string, periodo: number, mes: number, situac:any): Observable<any> {
    this.apiService.setUrlPathApi(`planilla-liquidacion/buscar/${libro}/${periodo}/${mes}`);
    return this.apiService.execGetQueryJson(`?situac=${situac}`).pipe();
  }
  getLibrosAsiento(): Observable<any> {
    this.apiService.setUrlPathApi(`planilla-liquidacion/libros`);
    return this.apiService.execGetQueryJson('').pipe();
  }

  descontabilizar(libro: string, periodo: number, mes: number, asiento: any): Observable<any> {
    this.apiService.setUrlPathApi(`planilla-liquidacion`+`/descontabilizar/${libro}/${periodo}/${mes}/${asiento}`);
    return this.apiService.executePutJson(null).pipe();
  }

  imprimir(planilla: string): Observable<any> {
    const fullUrl = environment.serviceUrl + `cliente/eecc/detalle-cobrar.pdf?` + "planilla=" + planilla;
    const httpOptions = {
        'responseType': 'arraybuffer' as 'json'
    };
    return this.http.get(fullUrl, httpOptions);
  }

  imprimirPagar(planilla: string): Observable<any> {
    const fullUrl = environment.serviceUrl + `cliente/eecc/detalle-pagar.pdf?` + "planilla=" + planilla;
    const httpOptions = {
        'responseType': 'arraybuffer' as 'json'
    };
    return this.http.get(fullUrl, httpOptions);
  }
  buscarOperacionesCxC(activo: any): Observable<any> {
    this.apiService.setUrlPathApi(`tbancos/buscar/cuentas-por-cobrar/planillas`);
    return this.apiService.execGetQueryJson(`?activo=${activo}`).pipe();
  }
  // anular(tipo: number, docume: number): Observable<any> {
  //   this.apiService.setUrlPathApi(ROUTE_CONTABILIDAD.registro_compra + `/anular/${tipo}/${docume}`);
  //   return this.apiService.executePutJson(null).pipe();
  // }

  // exportarExcelAsiento(): Observable<any> {
  //   this.apiService.setUrlPathApi(ROUTE_HERRAMIENTAS.exportacion);
  //   return this.apiService.execGetQueryJsonPDF(`download-formato-detalle-asiento`).pipe();
  // }

}